import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { Router } from "@angular/router";
import { MatButtonToggleGroup, MatButtonToggle } from "@angular/material/button-toggle";
import { NgStyle } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { EvCodiceFiscaleComponent } from "./ev-codice-fiscale.component";

export interface EvButtonToggle {
    text: string
    icon: string
    url: string
    value: string
    click: () => void
}

@Component({
    selector: 'ev-button-toggle',
    styles: [
        `
        :host {
            bottom: 0;
            display: block;
            left: 0;
            position: fixed;
            width: 100%;
            z-index: 1000;
        }
        mat-button-toggle-group {
            background: rgba(255, 255, 255, .98);
            border: 0;
            border-radius: 16px 16px 0 0;
            box-shadow: 0 -4px 18px rgba(24, 68, 64, .12);
            width: 100%;
        }
        mat-button-toggle {
            border: 0 !important;
            color: #63817e;
            min-height: 62px;
        }
        mat-button-toggle ::ng-deep .mat-button-toggle-label-content {
            align-items: center;
            display: flex;
            flex-direction: column;
            gap: 3px;
            justify-content: center;
            line-height: 1;
            padding: 7px 3px;
        }
        mat-button-toggle mat-icon { font-size: 21px; height: 21px; width: 21px; }
        .nav-label { font-size: 10px; font-weight: 600 !important; }
        `
    ],
    template: `
<mat-button-toggle-group aria-label="Navigazione rapida">
  @for (button of buttons; track button) {
    <mat-button-toggle
      [value]="button.value"
      (click)="handleClick(button)"
      [ngStyle]="{'width': (100 / buttons.length)+'%'}"
      [attr.aria-label]="button.text || button.value"
      >
      @if (button.icon) {
        <mat-icon>{{button.icon}}</mat-icon>
      }
      @if (button.text) {
        <span class="nav-label">{{button.text}}</span>
      }
    </mat-button-toggle>
  }
</mat-button-toggle-group>
`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonToggleGroup, MatButtonToggle, NgStyle, MatIcon]
})
export class EvButtonToggleComponent {
    private router = inject(Router);


    @Input() buttons: Partial<EvButtonToggle>[]

    handleClick(button: Partial<EvButtonToggle>) {
        if (button.click) {
            button.click()
        }
        if (button.url) {
            this.router.navigateByUrl(button.url)
        }
    }
}
